import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import Search, {
  ControlledInputType,
} from "common/Header/components/Search/Search";
import MobileMenuTrigger from "common/MobileMenuTrigger/MobileMenuTrigger";
import { useStore } from "store";
import { useBreakpoint } from "helpers/hooks";
import Favorites from "./components/Favorites/Favorites";
import Profile from "./components/Profile/Profile";
import Cart from "./components/Cart/Cart";
import Logo from "./components/Logo/Logo";
import styles from "./Main.module.scss";

const Main = () => {
  const searchRef = useRef<ControlledInputType>(null);
  const { header, search } = useStore();
  const breakpoint = useBreakpoint(true);
  const gtTablet = ["laptop", "desktop"].includes(breakpoint);

  useEffect(() => {
    const onwheel = () => {
      (header.menuMobileOpen || header.catalogMobileOpen) &&
        header.closeAllMenus();
      search.toggleShowSuggestions(false);
    };

    document.body.addEventListener("wheel", onwheel);

    return () => {
      document.body.removeEventListener("wheel", onwheel);
    };
  }, [header]);

  return (
    <div className={styles.main}>
      {!gtTablet && <MobileMenuTrigger />}

      {gtTablet && <Logo mobileIsOpen={header.menuMobileOpen} />}

      <Search
        ref={searchRef}
        stickyIsOpen={header.stickyHeader}
        className={styles.mainSearch}
      />

      {gtTablet && (
        <div className={styles.mainUser}>
          <Profile />
          <Favorites />
          <Cart />
        </div>
      )}
    </div>
  );
};

export default observer(Main);
